// services/employeeService.js - VERSION CORRIGÉE
import apiCall from './api';

export const employeeService = {

  /**
   * ✅ CORRIGÉ : Récupérer le dashboard employé spécifique
   * Maintenant utilise l'endpoint /employee/dashboard qui existe
   */
  getDashboard: async () => {
    try {
      
      const response = await apiCall.get('/employee/dashboard');
      
      if (response.success) {
        const data = response.data;
        
        // Les données arrivent déjà dans le bon format depuis le backend
        return {
          success: true,
          data: data, // Pas besoin de transformation, le backend envoie le bon format
          message: 'Dashboard employé spécifique récupéré avec succès'
        };
      } else {
        console.warn('⚠️ Erreur récupération dashboard spécifique:', response.message);
        throw new Error(response.message || 'Erreur lors du chargement du dashboard');
      }
    } catch (error) {
      console.error('❌ Erreur dashboard employé spécifique:', error);
      
      // Retourner une structure vide en cas d'erreur
      return {
        success: false,
        data: {
          myDailySales: { salesCount: 0, revenue: 0, lastSale: 'Aucune', lastSaleAmount: 0 },
          shopTotalToday: { salesCount: 0, revenue: 0 },
          myWeeklyStats: { salesCount: 0, revenue: 0, avgSaleValue: 0 },
          myMonthlyStats: { ranking: 1, target: 0, achieved: 0, progressPercent: 0, salesCount: 0, teamSize: 1 },
          topProducts: [],
          stockAlerts: [],
          recentSales: [],
          creditSales: [],
          employeeInfo: null,
          lastUpdated: new Date().toISOString()
        },
        error: error.message
      };
    }
  },

  /**
   * ✅ NOUVEAU : Récupérer mes ventes spécifiques
   */
  getMySales: async (startDate = null, endDate = null, limit = 100) => {
  try {
    
    const params = {};
    if (limit) params.limit = limit;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    // ✅ UTILISER LE BON ENDPOINT
    const response = await apiCall.get('/employee/sales/my', params);
    
    
    if (response.success) {
      
      // Pas besoin de transformation compliquée, juste s'assurer que c'est un tableau
      const sales = Array.isArray(response.data) ? response.data : [];
      
      return {
        success: true,
        data: sales
      };
    } else {
      console.warn('⚠️ Réponse non réussie:', response);
      return { success: false, data: [], message: response.message };
    }
    
  } catch (error) {
    console.error('❌ Erreur mes ventes spécifiques:', error);
    
    // ✅ FALLBACK: essayer l'endpoint général en cas d'échec
    try {
      const fallbackResponse = await apiCall.get('/employee/sales', { limit: limit || 100 });
      
      if (fallbackResponse.success) {
        return {
          success: true,
          data: fallbackResponse.data || []
        };
      }
    } catch (fallbackError) {
      console.error('❌ Fallback échoué aussi:', fallbackError);
    }
    
    return { 
      success: false, 
      data: [], 
      error: error.message || 'Erreur de connexion'
    };
  }
},

// ✅ AJOUTER AUSSI une méthode pour récupérer TOUTES les ventes d'employé :
getAllMySales: async (page = 0, size = 20) => {
  try {
    
    const response = await apiCall.get('/employee/sales', { page, size });
    
    if (response.success) {
      return {
        success: true,
        data: response.data || []
      };
    }
    
    return { success: false, data: [] };
    
  } catch (error) {
    console.error('❌ Erreur toutes mes ventes:', error);
    return { success: false, data: [], error: error.message };
  }
},

  /**
   * ✅ NOUVEAU : Récupérer mes statistiques personnelles
   */
  getMyPersonalStats: async (startDate = null, endDate = null) => {
    try {
      
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      
      const response = await apiCall.get('/employee/stats/my', params);
      
      if (response.success) {
        const stats = response.data;
        
        return {
          success: true,
          data: stats
        };
      }
      
      return { success: false, data: null };
      
    } catch (error) {
      console.error('❌ Erreur mes statistiques personnelles:', error);
      return { success: false, data: null, error: error.message };
    }
  },

  /**
   * ✅ Récupérer les produits disponibles
   */
  getProducts: async () => {
    try {
      const response = await apiCall.get('/employee/products');
      return response;
    } catch (error) {
      console.error('❌ Erreur récupération produits:', error);
      return { success: false, data: [] };
    }
  },

  /**
   * ✅ Créer une nouvelle vente
   */
  createSale: async (saleData) => {
    try {
      const response = await apiCall.post('/employee/sales', saleData);
      return response;
    } catch (error) {
      console.error('❌ Erreur création vente:', error);
      return { success: false, message: 'Erreur lors de la création de la vente' };
    }
  },

  /**
   * ✅ Récupérer les clients
   */
  getCustomers: async (searchTerm = '') => {
    try {
      const params = searchTerm ? { search: searchTerm } : {};
      const response = await apiCall.get('/employee/customers', params);
      return response;
    } catch (error) {
      console.error('❌ Erreur récupération clients:', error);
      return { success: false, data: [] };
    }
  },

  /**
   * ✅ Créer un nouveau client
   */
  createCustomer: async (customerData) => {
    try {
      const response = await apiCall.post('/employee/customers', customerData);
      return response;
    } catch (error) {
      console.error('❌ Erreur création client:', error);
      return { success: false, message: 'Erreur lors de la création du client' };
    }
  }
};

export default employeeService;